import { LitElement, html, css } from 'lit-element';
import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import './site-token-list';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
const { CAN_MANAGE_MASTER_TOKENS } = AUTHORIZATIONS;

class SiteTokens extends LitElement {
    constructor() {
        super();
    }
    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex: 1;
                    flex-flow: column;
                }
                :host([hidden]) {
                    display: none;
                }
            `,
        ];
    }

    static get properties() {
        return {
            tokens: {
                type: Array,
            },
            authorizations: {
                type: Array,
            },
            siteGuid: {
                type: String,
            },
            isLoading: {
                typ: Boolean,
            },
        };
    }

    updated(changedProps) {
        if (changedProps.has('siteGuid')) {
            const { authorizations, siteGuid } = this;
            if (authorizations.includes(CAN_MANAGE_MASTER_TOKENS)) {
                if (siteGuid) {
                    this.actions.fetchSiteTokens({ guid: siteGuid });
                }
            } else {
                this.actions.clearSiteTokens();
            }
        }
    }

    render() {
        return html`
            <h2>Site Tokens</h2>
            <div>${this.renderSiteTokens()}</div>
        `;
    }

    renderSiteTokens() {
        const { tokens = [], authorizations, siteGuid } = this;
        if (this.isLoading) {
            return html`<div>Loading...</div>`;
        }
        return html`
            <site-token-list
                .siteGuid=${siteGuid}
                .authorizations=${authorizations}
                .tokens=${tokens}></site-token-list>
        `;
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const siteData = selectors.siteStagedEditsSelector(state);
        return {
            tokens: selectors.siteTokensSelector(state),
            siteGuid: siteData?.guid,
            isLoading: selectors.tokenListIsLoadingSelector(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
};

customElements.define('site-tokens', connect(mapStateToProps, combinedActions)(SiteTokens));
